import { useState, useEffect } from "react";

const HEX_64 = /^[0-9a-f]{64}$/;

/** Accepts "ab12...", "AB12...", or the colon-separated form apksigner prints. */
function normalizeSha256(value) {
  if (typeof value !== "string") return null;
  const hex = value.replace(/[:\s]/g, "").toLowerCase();
  return HEX_64.test(hex) ? hex : null;
}

/**
 * Fetches /apk/release.json at runtime and returns the current APK release.
 *
 *   {
 *     "version":       "42",                      shown in the modal and the file name
 *     "url":           "https://.../biorvault.apk",
 *     "sha256":        "<64 hex>" | null,         SHA-256 of the served APK file
 *     "signer_sha256": "<64 hex>" | null          SHA-256 of the APK signing certificate
 *   }
 *
 * The integrity fields are optional in the schema and rendered only when they
 * hold a valid digest. README.md ("Android APK release") says who fills them.
 */
export function useApkRelease() {
  const [state, setState] = useState({
    version: null,
    url: null,
    sha256: null,
    signerSha256: null,
    loaded: false,
  });

  useEffect(() => {
    fetch("/apk/release.json", { cache: "no-cache" })
      .then((r) => {
        if (!r.ok) throw new Error("not found");
        return r.json();
      })
      .then((data) => {
        setState({
          version: data.version ?? null,
          url: data.url ?? null,
          sha256: normalizeSha256(data.sha256),
          signerSha256: normalizeSha256(data.signer_sha256),
          loaded: true,
        });
      })
      .catch(() => {
        setState({ version: null, url: null, sha256: null, signerSha256: null, loaded: true });
      });
  }, []);

  return state;
}
